export default __webpack_public_path__ + "static/media/Icon.97db1859.svg";